@if (hasEdits) {
  <div class="sidebar-reference-question-set-edits-card mt-2"><app-card [isHeaderLeft]="false">
    <div class="app-card-right">
      <div class="row">
        <div class="col-12">
          <h5 class="small text-muted mb-2">{{ 'SIDEBAR.REFERENCE_EDITS' | translate }}</h5>
          <ul class="list-unstyled mb-0">
            @for (row of rows; track row.fieldName) {
              <li class="small mb-1" data-testid="edits-card-row"><span class="text-muted">{{ row.label }}:</span><span class="ms-2 text-muted text-decoration-line-through" data-testid="edits-card-original">{{ row.original }}</span><span class="ms-2 text-muted">→</span><span class="ms-2" data-testid="edits-card-current">{{ row.current }}</span></li>
            }
          </ul>
        </div>
      </div>
    </div>
  </app-card></div>
}
